import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './styles.module.scss';
import { Board } from '../../../../../components/Board';
import { NavButton } from '../../../../../components/NavButton';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { useNavigate } from 'react-router-dom';

import 'moment/locale/pt';

export const ConfigTeste = () => {
    const navigate = useNavigate();

    // Estados para os campos
    const [nome, setNome] = useState(''); // desc
    const [descPilar, setDescPilar] = useState(''); // Novo campo
    const [imagem, setImagem] = useState(null); // logo (arquivo)
    const [form, setForm] = useState(null); // form (arquivo)
    const [user, setUser] = useState();
 useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );
        setUser(user);
    }, []);

       const requestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${user?.token}`,
                Accept: 'application/json'
            }
        };

    const goBackwards = () => {
        navigate('/manager');
    };

    // Função utilitária para converter File para Base64 (Promisified)
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    // Carregar configurações atuais ao iniciar
    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = async () => {
        try {
            // Ajuste a rota conforme seu arquivo de rotas do Laravel (ex: Route::get('/teste/config', ...))
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/manager/teste/config`,requestConfig);
            const data = response.data;
            
            if (data) {
                if (data.desc) setNome(data.desc);
                if (data.descPilar) setDescPilar(data.descPilar);
                // Imagens geralmente não se "seta" no input file, mas poderíamos mostrar um preview se quisesse
            }
        } catch (error) {
            console.error('Erro ao buscar configurações:', error);
        }
    };

    const sendForm = async () => {
        try {
            const payload = {};

            // Adiciona campos de texto
            if (nome) payload.desc = nome;
            if (descPilar) payload.descPilar = descPilar;

            // Converte e adiciona imagens se foram selecionadas
            if (imagem) {
                payload.logo = await getBase64(imagem);
            }

            if (form) {
                payload.form = await getBase64(form);
            }

            // Envia tudo em uma única requisição para o método update
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/teste/config`, // Certifique-se que essa rota aponta para ConfigTeste@update
                payload,
                requestConfig
            );

            alert('Configuração atualizada com sucesso!');
            
            // Opcional: Recarregar dados ou limpar inputs de arquivo
            setImagem(null);
            setForm(null);
            fetchConfig();

        } catch (error) {
            if (error.response && error.response.status === 422) {
                alert('Erro de validação: ' + JSON.stringify(error.response.data.errors));
            } else {
                alert('Erro ao atualizar: ' + (error.message || 'Erro desconhecido'));
            }
            console.error(error);
        }
    };

    return (
        <div className={styles.wrapper}>
            <NavButton
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                onClick={goBackwards}
            />

            <Board wrapperClass={styles.board}>
                <div className={styles.container}>
                    <h1 className={styles.titulo}>Edição de Configurações</h1>
                    
                    <label>Título / Texto Introdutório</label>
                    <input
                        type='text'
                        placeholder='Descrição de texto introdutório'
                        value={nome}
                        onChange={e => setNome(e.target.value)}
                        className={styles.inputField} // Assumindo que você tenha estilos
                    />

                    <label style={{marginTop: '20px', display: 'block'}}>Descrição dos Pilares</label>
                    <textarea
                        placeholder='Texto explicativo sobre os pilares...'
                        value={descPilar}
                        onChange={e => setDescPilar(e.target.value)}
                        rows={4}
                        style={{width: '100%', padding: '10px'}}
                    />

                    <h2 style={{marginTop: '20px'}}>Logo do Formulário</h2>
                    <input
                        type='file'
                        accept='image/*'
                        onChange={e => setImagem(e.target.files && e.target.files[0])}
                    />
                    <div style={{marginTop: '30px'}}>
                        <button
                            type='button' // Importante ser type='button' para não recarregar página se estiver num form
                            onClick={sendForm}
                            style={{ 
                                backgroundColor: 'green', 
                                color: 'white', 
                                padding: '10px 20px', 
                                border: 'none', 
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Salvar Alterações
                        </button>
                    </div>
                </div>
            </Board>
        </div>
    );
};